import { Lottie } from '@alfonmga/react-lottie-light-ts';
import { css } from '@emotion/css';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CnWelcomeAnim from '../../assets/anim/welcome-long/welcome-cn.json';
import EnWelcomeAnim from '../../assets/anim/welcome-long/welcome-en.json';
import JaWelcomeAnim from '../../assets/anim/welcome-long/welcome-ja.json';
import KoWelcomeAnim from '../../assets/anim/welcome-long/welcome-ko.json';
import TwWelcomeAnim from '../../assets/anim/welcome-long/welcome-tw.json';
import CnWelcomeShortAnim from '../../assets/anim/welcome-short/welcome-cn-short.json';
import EnWelcomeShortAnim from '../../assets/anim/welcome-short/welcome-en-short.json';
import JaWelcomeShortAnim from '../../assets/anim/welcome-short/welcome-ja-short.json';
import KoWelcomeShortAnim from '../../assets/anim/welcome-short/welcome-ko-short.json';
import TwWelcomeShortAnim from '../../assets/anim/welcome-short/welcome-tw-short.json';
import { RootState } from '../../features/index.js';
import { actions } from '../../features/user';
import { usePrefersReducedMotion } from '../shared/usePrefersReducedMotion';

const WelcomeAnimationStyles = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  svg {
    border-radius: 80px;
  }
`;

const CompleteWithoutAnim: React.FC<{ onComplete: () => void }> = ({ onComplete }) => {
  useEffect(() => {
    onComplete();
  }, [onComplete]);
  return <></>;
};

export const WelcomeAnimation: React.FC = () => {
  const dispatch = useDispatch();
  const { marked } = useSelector((state: RootState) => state.user);
  const { i18n } = useTranslation();
  const prefersReducedMotion = usePrefersReducedMotion();
  const onComplete = useCallback(() => {
    dispatch(actions.splashFinished());
  }, [dispatch]);

  const welcomeAnim = getLocalizedAnimation(i18n.language, marked);

  return (
    <div className={WelcomeAnimationStyles}>
      {prefersReducedMotion ? (
        <CompleteWithoutAnim onComplete={onComplete} />
      ) : (
        <Lottie
          config={{
            animationData: welcomeAnim,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice'
            }
          }}
          lottieEventListeners={[
            {
              name: 'complete',
              callback: onComplete
            }
          ]}
        />
      )}
    </div>
  );
};

// helper function
function getLocalizedAnimation(lang: string, marked?: boolean) {
  if (marked) {
    switch (lang) {
      case 'ja':
      case 'ja-JP':
        return JaWelcomeShortAnim;
      case 'zh':
      case 'zh-CN':
        return CnWelcomeShortAnim;
      case 'zh-TW':
        return TwWelcomeShortAnim;
      case 'ko':
      case 'ko-KR':
        return KoWelcomeShortAnim;
      default:
        return EnWelcomeShortAnim;
    }
  } else {
    switch (lang) {
      case 'ja':
      case 'ja-JP':
        return JaWelcomeAnim;
      case 'zh':
      case 'zh-CN':
        return CnWelcomeAnim;
      case 'zh-TW':
        return TwWelcomeAnim;
      case 'ko':
      case 'ko-KR':
        return KoWelcomeAnim;
      default:
        return EnWelcomeAnim;
    }
  }
}
